.code-block {
  max-height: 200px;
  margin: 0;
  overflow: auto;
}
